
import React from 'react';
import { DraggableKpiCard } from '@/components/kpi/DraggableKpiCard';
import { KpiItem } from '@/hooks/useKpiLayout';

interface KpiCardsGridProps {
  visibleKpis: KpiItem[];
  editMode: boolean;
  toggleVisibility: (id: string) => void;
  handleCardClick: (id: string) => void;
}

export const KpiCardsGrid: React.FC<KpiCardsGridProps> = ({
  visibleKpis,
  editMode,
  toggleVisibility,
  handleCardClick
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 theme-transition">
      {visibleKpis.map((kpi, index) => (
        <DraggableKpiCard
          key={kpi.id}
          id={kpi.id}
          index={index}
          title={kpi.title}
          value={kpi.value}
          unit={kpi.unit}
          trend={kpi.trend}
          isPositive={kpi.isPositive}
          icon={kpi.icon}
          colorClass={kpi.colorClass}
          isDraggable={false}
          onHide={() => toggleVisibility(kpi.id)}
          onClick={() => handleCardClick(kpi.id)}
        />
      ))}
    </div>
  );
};

export default KpiCardsGrid;
